export default "__VITE_ASSET__2c5d66c9__"